import { useTranslation } from 'react-i18next'
import useProjectAddPage from './hooks/useProjectAddPage'

export default function ProjectAdd() {
	const { t } = useTranslation()
	const { form, setField, submitting, handleCancel, handleSubmit } = useProjectAddPage()

	return (
		<div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
			<div className="mb-6">
				<h1 className="text-2xl font-semibold text-gray-900">
					{t('projects.add.title', { defaultValue: 'Nowy projekt' })}
				</h1>
				<p className="mt-1 text-sm text-gray-500">
					{t('projects.add.subtitle', { defaultValue: 'Podaj nazwę projektu. Szczegóły planu uzupełnisz na stronie projektu.' })}
				</p>
			</div>

			<form className="space-y-6 rounded-lg border border-gray-200 bg-white p-6 shadow-sm" onSubmit={handleSubmit}>
				<label className="flex flex-col gap-1">
					<span className="text-sm font-medium text-gray-700">
						{t('projects.form.fields.projectName', { defaultValue: 'Nazwa projektu' })} *
					</span>
					<input
						type="text"
						required
						className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
						value={form.nazwa}
						onChange={e => setField('nazwa', e.target.value)}
					/>
				</label>

				<div className="flex justify-end gap-3 border-t border-gray-200 pt-4">
					<button
						type="submit"
						disabled={submitting}
						className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
					>
						{submitting
							? t('projects.add.submitting')
							: t('projects.add.submit', { defaultValue: 'Utwórz projekt' })}
					</button>
					<button
						type="button"
						onClick={handleCancel}
						className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50"
					>
						{t('projects.add.cancel')}
					</button>
				</div>
			</form>
		</div>
	)
}
